/* eslint-disable */

import $ from 'jquery';

var SemanticSelect = function(SemanticSelect){
  "use strict";

  SemanticSelect.activeClass = 'selectField-showLabel';

  SemanticSelect.init = function() {
    SemanticSelect.initSelectFields();
    SemanticSelect.initIntegratedLabels();

    SemanticSelect.initListeners();
  };

  SemanticSelect.initSelectFields = function() {
    var $selectField = $('.selectField');
    var $selectField_select = $selectField.find('select');

    $selectField.each(function(index, element){
      var $select = $(element);
      if($select.hasClass('search')){
        $select.find('select').addClass('search');
      }
    });
    initSemanticDropdown($selectField_select);
  };


  ////// Listeners
  SemanticSelect.initListeners = function() {
    var $formField = $('.formField.selectField.search');
    $formField.on('blur', ':input', SemanticSelect.forceValue);

    $formField.find('input.search').on('keydown, keyup', SemanticSelect.manageSearchLabel);
    // $formField.find('select').on('change', SemanticSelect.manageSearchLabel);
    $('select').on('Form:UpdateLabel', function () {
      var semanticSelect = $(this).closest('.selectField');
      SemanticSelect.manageIntegratedLabel(semanticSelect);
    });
  };


  ////// Integrated labels
  SemanticSelect.initIntegratedLabels = function () {
    var $selectField = $('.selectField');
    $selectField.each(function(index, element){
      var $select = $(element);
      SemanticSelect.manageIntegratedLabel($select);
    });
  };

  SemanticSelect.manageIntegratedLabel = function ($semanticSelect) {
    var $selectedOption = $semanticSelect.find('option:selected');
    var selectedOptionValue = $selectedOption.val();
    var selectedOptionText = $selectedOption.text();
    var isSelectionEmpty = selectedOptionValue === '' && selectedOptionText === '';

    $semanticSelect.addClass(SemanticSelect.activeClass);
    // When an emty option is selected we don't integrate the label
    if (isSelectionEmpty) {
      $semanticSelect.removeClass(SemanticSelect.activeClass);
    }
  };

  SemanticSelect.manageSearchLabel = function (e) {
    var $searchInput = $(this);
    var $semanticSelect = $searchInput.closest('.selectField_select');
    var $formField = $semanticSelect.closest('.formField');

    // search value
    var searchValue = $searchInput.val();

    // selected value
    var $selectedOption = $semanticSelect.find('option:selected');
    var selectedOptionValue = $selectedOption.val();
    var selectedOptionText = $selectedOption.text();
    var isSelectionEmpty = selectedOptionValue === '' && selectedOptionText === '';

    $formField.addClass('selectField-showLabel');
    if (!searchValue && isSelectionEmpty) {
      $formField.removeClass('selectField-showLabel');
    }
  };


  // Remove the search query and show the selected value
  SemanticSelect.forceValue = function() {
    var $this = $(this);
    var $formField = $this.closest('.formField');
    var $semanticSearchSelect = $formField.find('.selectField_select.search');

    var selectedValue = $semanticSearchSelect.dropdown('get value');
    $this.val('');
    $semanticSearchSelect.dropdown('set selected', selectedValue);
  };


  ////// Validate selection
  SemanticSelect.getValidationErrors = function () {
    var validationErrors = [];
    var $this = $(this);
    var $semanticSearchSelect = $this.find('.selectField_select.search');
    var selectedValue = $semanticSearchSelect.dropdown('get value');
    var isRequired = $this.children('.selectField_select').hasClass('required');

    if (!selectedValue && isRequired) {
      // It seems there is always one selected, even with force selection off.
      validationErrors.push('Dit veld is verplicht');
    }

    return validationErrors;
  };



  // Privates
  var initSemanticDropdown = function ($elements){
    var settings = {
      onShow: function(){
        $(this).closest('.selectField').addClass('active');
      },
      onHide: function(){
        var $select = $(this);
        var $parent = $select.closest('.selectField');
        $parent.removeClass('active');
        SemanticSelect.manageIntegratedLabel($parent);
      },
      placeholder: false,
      match: 'text',
      direction: 'downward',
      forceSelection: true
    };

    $elements.each(function(i, element){
      var $element = $(element);
      if ($element.data('select-options')) {
        settings = $.extend(settings, $element.data('select-options'));
      }
      $element.dropdown(settings);
    });

    return $elements;
  };

  return SemanticSelect;
}(SemanticSelect || {});


export default SemanticSelect;
